module.exports = __webpack_public_path__ + "img/pl.ee17d4fb.svg";